module.exports = __webpack_public_path__ + "static/media/people-leadershiping.2c0150d6.png";